/**
 * Direct REST API client that bypasses Amplify SigV4 request signing.
 * Prevents "CognitoIdentityCredentials is not authorized to perform: execute-api:Invoke" errors.
 */

const API_BASE_URL = (process.env.REACT_APP_ENV_API_URL || '').replace(/\/$/, '');

export async function apiRequest(path, method = 'GET', body = null, headers = {}) {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    const url = `${API_BASE_URL}${cleanPath}`;

    const config = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...headers
        }
    };

    if (body) {
        config.body = typeof body === 'string' ? body : JSON.stringify(body);
    }

    const response = await fetch(url, config);
    const text = await response.text();

    let data;
    try {
        data = JSON.parse(text);
    } catch {
        data = text;
    }

    if (!response.ok) {
        const error = new Error(data?.message || data?.error || `HTTP ${response.status} Error`);
        error.status = response.status;
        error.response = { data, status: response.status };
        throw error;
    }

    return data;
}

export const api = {
    get: (path, headers) => apiRequest(path, 'GET', null, headers),
    post: (path, body, headers) => apiRequest(path, 'POST', body, headers)
};

export default api;
